
exports.speechText = function (text) {
    window.speechSynthesis.getVoices();
    // 読み上げたい文字列
    const utter = new SpeechSynthesisUtterance(text);
    const voice = window.speechSynthesis.getVoices()[0];
    utter.voice = voice;
    window.speechSynthesis.speak(utter);
}
